import { useTranslations } from "contexts/LocalizationContext";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter/RichtextAdapter";
import { contentStyles } from "modules/storyblok/adapters/Content";
import { Box, Text } from "@chakra-ui/react";
import type { PieChartTextProps } from "./PieChart.d";

const PieChartText = ({ text, styles }: PieChartTextProps) => {
  const translations = useTranslations();
  const isTextAString = typeof text === "string";

  return (
    <Box mx={2} mb={8}>
      {!isTextAString ? (
        <RichtextAdapter content={text} customStyles={{ ...contentStyles, ...styles }} />
      ) : (
        <Text fontSize="lg">{translations(text)}</Text>
      )}
    </Box>
  );
};

export default PieChartText;
